import React from "react";
import { Navigate } from "react-router";

export interface AppRedirectProps {
  to: string;
}

/** Router-owned replacement navigation. Swap only this implementation in Router 6/7. */
export function AppRedirect({ to }: AppRedirectProps) {
  return <Navigate replace to={to} />;
}

export const AgreementFormRedirect = () => <AppRedirect to="/agreement" />;
export const CriticalPathProposalRedirect = () => <AppRedirect to="/critical-paths" />;
export const CustodialRequestIndexRedirect = () => <AppRedirect to="/custodial-requests" />;
export const ImplementRedirect = () => <AppRedirect to="/proposals" />;
